import { IMenuAccess, IMenuDefinition } from "interfaces";
import strings from "strings";

const menus: IMenuDefinition[] = [
  { name: strings.MENU.DASHBOARD,       url: strings.ROUTES.DASHBOARD,       canViewMenu: () => true },
  { name: strings.MENU.CARRIERS,        url: strings.ROUTES.CARRIERS,        canViewMenu: () => true },
  { name: strings.MENU.FLEET_REPORTING, url: strings.ROUTES.FLEET_REPORTING, canViewMenu: () => true },
  { name: strings.MENU.PROFILE,         url: strings.ROUTES.PROFILE,         canViewMenu: () => true },
]

const getAgentMenuAccess = (): IMenuAccess[] => {
  const menuList: IMenuAccess[] = menus
    .filter(menu => menu.canViewMenu())
    .map(({ name, url }) => ({ name, url }))

  menuList.push({ name: strings.MENU.HELP })

  return menuList
}

export default getAgentMenuAccess
